import React from "react"
import Button from "@common/Button/Button"
import arrowIcon from "@images/right-arrow.svg"
import { MAIN_BUTTON } from "@constants"
import banner from "./602.png"
import { DIVE_IN_ACTION_BUTTON_CLASSNAME, DIVE_IN_ACTION_ID } from "./constants"
import {
  StyledDiveInActionWrapper,
  StyledDiveInActionContainer,
  StyledTextContainer,
  StyledTitle,
  StyledDescription,
  StyledButtonContainer,
  StyledCaseTitle,
} from "./styled"

const DiveInAction = ({
  title = "",
  description = "",
  buttonText = "Dive in",
  imageUrl = "",
  buttonNavigationPath = "",
}) => {
  return (
    <StyledDiveInActionWrapper
      id={DIVE_IN_ACTION_ID}
      image={imageUrl}
      banner={banner}
    >
      <StyledDiveInActionContainer>
        <StyledTextContainer>
          <StyledTitle>{title}</StyledTitle>
          <StyledDescription>{description}</StyledDescription>
        </StyledTextContainer>
        <StyledButtonContainer href={buttonNavigationPath}>
          <Button
            className={DIVE_IN_ACTION_BUTTON_CLASSNAME}
            text={buttonText}
            type={MAIN_BUTTON}
            bannerButtonIconPath={arrowIcon}
          />
        </StyledButtonContainer>
      </StyledDiveInActionContainer>
      <StyledCaseTitle>case study</StyledCaseTitle>
    </StyledDiveInActionWrapper>
  )
}

export default DiveInAction
